const sizes = {
  app: '1280px',
};

export default sizes;
